import { Node, mergeAttributes } from '@tiptap/core'

export const VariableWrapper = Node.create({
  name: 'variableWrapper',

  group: 'inline',

  inline: true,

  content: 'inline*', // Can contain inline content (text, marks, etc.)

  addAttributes() {
    return {
      class: {
        default: 'variable-wrapper',
        parseHTML: element => element.getAttribute('class'),
        renderHTML: attributes => {
          return {
            class: attributes.class || 'variable-wrapper'
          }
        }
      },
      contenteditable: {
        default: 'false',
        parseHTML: element => element.getAttribute('contenteditable'),
        renderHTML: attributes => {
          return {
            contenteditable: attributes.contenteditable || 'false'
          }
        }
      }
    }
  },

  parseHTML() {
    return [
      {
        tag: 'span.variable-wrapper'
      }
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes(HTMLAttributes, { class: 'variable-wrapper', contenteditable: 'false' }), 0]
  }
})
